import { useEffect } from 'react';

import { MultiSelect } from 'ui';

import { RightSection } from './RightSection';
import { useSearchableInput } from './hooks';
import { SearchableMultiSelectWithOptionData } from './types';

const SearchableMultiSelect = ({
  data,
  comboboxProps,
  useFetchSource,
  value,
  onChange,
  // This is to handle a misspelling of the placeholder prop...
  placeHolder,
  placeholder,
  dataRef,
  multiSelectDataRef,
  initialData,
  ...rest
}: SearchableMultiSelectWithOptionData) => {
  const {
    isLoading,
    fetchedData,
    props,
    onSearchChange,
    searchValue,
    onMultiSelectChange,
    _multiSelectValue: multiSelectValue,
  } = useSearchableInput({
    type: 'multi-select',
    useFetchSource,
    onChange,
    initialData,
  });
  // The placeholder prop is spelled incorrectly, so we need to check for both- db- 14/02/2024
  const correctlySpelledPlaceholder = placeholder ?? placeHolder;
  // If there is value entries, then we don't want to show the placeholder
  const _placeHolder = value && value.length ? undefined : correctlySpelledPlaceholder;

  /**
   * used to bind the data to the ref so that it can be accessed outside of the component if needed
   */
  useEffect(() => {
    if (dataRef) {
      dataRef.current = data ?? fetchedData ?? [];
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, fetchedData]);
  /**
   * used to bind the selected multiselect data to the ref so that it can be accessed outside of the component if needed
   */
  useEffect(() => {
    if (multiSelectDataRef) {
      multiSelectDataRef.current = multiSelectValue;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [multiSelectValue]);

  return (
    <MultiSelect
      value={value}
      data={data ?? fetchedData ?? []}
      onChange={onMultiSelectChange}
      onSearchChange={onSearchChange}
      searchValue={searchValue}
      {...rest}
      {...props}
      // Do not show a nothing found message when we could be in a loading state
      rightSection={
        <RightSection
          isLoading={isLoading}
          value={value}
          onChange={() => onMultiSelectChange([])}
        />
      }
      placeholder={_placeHolder}
      comboboxProps={comboboxProps}
    />
  );
};

export { SearchableMultiSelect };
